import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UITimelineComponent } from './ui-timeline/ui-timeline.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TimelineComponent } from './ui-timeline/timeline.component';
import { LongPressDirective } from './ui-timeline/long-press.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forRoot()
  ],
  declarations: [
    UITimelineComponent,
    TimelineComponent,
    LongPressDirective
  ],
  exports: [
    CommonModule,
    LongPressDirective,
    UITimelineComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsO5Module { }
